import { trackUsage } from '@creditsights/api-ui-web';
import { getMarketStatRegion } from './marketStats.utils';

export enum AnalystBioEvents {
  ANALYST_BIO_LOAD_MORE_ARTICLES = 'ANALYST_BIO_LOAD_MORE_ARTICLES',
  ANALYST_BIO_LINKEDIN_NAVIGATION = 'ANALYST_BIO_LINKEDIN_NAVIGATION',
  ANALYST_BIO_COVERAGE_ISSUER_NAVIGATION = 'ANALYST_BIO_COVERAGE_ISSUER_NAVIGATION',
  ANALYST_BIO_ARTICLE_NAVIGATION = 'ANALYST_BIO_ARTICLE_NAVIGATION',
}

export interface AnalystBioTrackData {
  event: string;
  coverageIssuer?: string;
  articleId?: string;
}

export const trackAnalystBioUsage = (data: AnalystBioTrackData, analystName: string | undefined): void => {
  const { event, coverageIssuer, articleId } = data;
  const options = [
    {
      key: 'analystName',
      value: String(analystName),
    },
  ];

  if (coverageIssuer) {
    options.push({
      key: 'coverageIssuer',
      value: coverageIssuer,
    });
  }

  if (articleId) {
    options.push({
      key: 'articleId',
      value: String(articleId),
    });
  }
  trackUsage(event, options);
};

export enum UserProfileEvents {
  USER_PROFILE_PERSONAL_INFORMATION_SAVED = 'USER_PROFILE_PERSONAL_INFORMATION_SAVED',
  USER_PROFILE_WORK_ADDRESS_SAVED = 'USER_PROFILE_WORK_ADDRESS_SAVED',
  USER_PROFILE_PASSWORD_SAVED = 'USER_PROFILE_PASSWORD_SAVED',
}

export const trackUserProfileUsage = (event: string): void => {
  trackUsage(event);
};

export enum TrackUsageEvents {
  MARKET_STATS_FILE_DOWNLOAD = 'MARKET_STATS_FILE_DOWNLOAD',
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const trackMarketStatsFileDownload = (type: string, fileTitle: string, region: string, fileData, sectionData): void => {
  trackUsage(TrackUsageEvents.MARKET_STATS_FILE_DOWNLOAD, [
    {
      key: 'type',
      value: type,
    },
    {
      key: 'fileTitle',
      value: fileTitle,
    },
    {
      key: 'fileName',
      value: `${fileData.fileName}`,
    },
    {
      key: 'fileExtension',
      value: `${fileData.extension}`,
    },
    {
      key: 'sectionName',
      value: `${sectionData.name}`,
    },
    {
      key: 'region',
      value: `${getMarketStatRegion(region)}`,
    },
  ]);
};
